import React from "react";
import { useMemo } from "react";
import store from "../../store/store";
import ThemeCard from "../../components/ThemeCard";
import { Col, Collapse, Row, Skeleton, notification, Pagination } from "antd";
import ThemeDatePicker from "../../components/ThemeDatePicker";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import EndPoints from "../../APICall/EndPoints";
import APICall from "../../APICall";
import UserFilterComponant from "../../components/UserFilterComponant/UserFilterComponant";
import { setUserClearFilter } from "../../store/slice/globleSlice";
import MarketScriptList from "../../components/MarketScriptList/MarketScriptList";
import {
  formatToINR,
  formatNumber,
} from "../../components/FormateToINR/formatToINR";
import { useQuery } from "@tanstack/react-query";
import {
  resetPositionSocketSlice,
  setPositionConnect,
} from "../../store/slice/positionSocketSlice";
import {
  CardDetailText,
  CardTitleText,
  MarketTypeRadio,
  StyleRow,
  StyledLabel,
  TitleRow,
  options1,
  options2,
  style,
} from "./style";
import {
  ScriptName,
  TotalMTM,
  TotalOutstanding,
  TotalPNL,
} from "./Components/tradePositionComponent";
import useGetQueryParams from "../../hooks/useGetQueryParams";
import dayjs from "dayjs";
import { valanBillDate } from "../../components/CommanFuction/CommanFunction";
import { StyledButton } from "../../styles/commonStyle";
import PositionTable from "./PositionTable";
import ValanComponant from "../../components/ValanComponant/ValanComponant";
import { useSocket } from "../../components/Socket";

function TradingPosition() {
  //state
  const [value, setValue] = useState({
    radioClient: 0,
    radioAll: 2,
    asOnDate: null,
  });
  const [closePositionLoading, setClosePositionLoading] = useState(false);
  const [rolloverLoading, setRolloverLoading] = useState(false);
  const [position, setPosition] = useState([]);
  const [groupTotals, setGroupTotals] = useState({});
  const [clearSelect, setClearSelect] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [totalCount, setTotalCount] = useState(0);

  const { params, setSearchParams } = useGetQueryParams();
  const valueRef = useRef({});
  const activeRef = useRef();
  const currentPriceRef = useRef({});
  const dispatch = useDispatch();
  //redux
  const userIP = useSelector((state) => state.authSlice?.user?.userIP) || "";
  const loginDetails = useSelector((state) => state.authSlice?.userDetail);
  const loginUserId = loginDetails?.userId;
  const loginAccountType = loginDetails?.accountType;
  const userMarkets = useSelector(
    (state) => state?.globleSlice?.marketListData
  );
  const isBroker = loginAccountType === "broker";
  const isCustomer = loginAccountType === "customer";
  const isOwner = loginAccountType === "owner";
  const summaryPosition = useSelector(
    (state) => state?.globleSlice?.positionFromSummay?.userId
  );
  const filterUser = useSelector((state) => state?.globleSlice?.filterUsers);
  const m2mSummary = useSelector(
    (state) => state?.positionSocketSlice?.m2mSummary
  );
  const socketLogs = useSelector(
    (state) => state?.positionSocketSlice?.socketLogs
  );
  const { doSendPosition } = useSocket();

  // api
  const getPositions = async () => {
    let isAllow = filterUser?.includes(Number(params?.userId));
    if (!isAllow) {
      notification.error({ message: "User Id is not valid" });
      return [];
    }
    let payloadObj = {
      userId: Number(params?.userId),
      marketName: params?.marketName || null,
      symbolName: params?.symbolName || null,
      expiryDate: params?.expiryDate || null,
      asOnDate: params?.asOnDate || null,
      // page: currentPage,
      // limit: pageSize,
      // groupBy: value?.radioClient === 0 ? "clientwise" : "symbolwise",
    };
    if (params?.valanId) payloadObj.valanId = params.valanId;

    let response = await APICall("post", EndPoints?.tradePosition, payloadObj);
    const posData = response?.data?.data?.data;
    setTotalCount(response?.data?.data?.totalCount || 0);

    doSendPosition({ event: "m2mUpdates", payload: "payload" });

    if (posData) {
      const totals = {};
      posData.forEach((group) => {
        const key =
          group.groupKey ||
          (value?.radioClient === 0
            ? `${group?.user?.[0]?.accountName}_${group?.user?.[0]?.userId}`
            : group?.symbol);
        if (group.totalPnl !== undefined) {
          totals[key] = group.totalPnl;
        }
      });
      setGroupTotals((prev) => ({ ...prev, ...totals }));
    }
    return posData;
  };

  const {
    isLoading,
    data,
    error: positionError,
  } = useQuery({
    queryKey: [
      "getPositionData",
      params,
      currentPage,
      pageSize,
      value?.radioClient,
    ],
    queryFn: getPositions,
    enabled: Object.keys(params)?.length > 0,
  });

  if (positionError) notification.error({ message: positionError?.message });

  // life cycle
  useEffect(() => {
    if (isCustomer) {
      setValue((pre) => ({ ...pre, radioClient: 1 }));
    }
    setSearchParams({
      ...params,
      userId: params?.userId
        ? params.userId
        : summaryPosition
        ? summaryPosition
        : loginUserId,
    });
    if (params?.asOnDate) {
      setValue((pre) => ({ ...pre, asOnDate: dayjs(params?.asOnDate) }));
    }
    dispatch(setPositionConnect(true));

    return () => {
      dispatch(setPositionConnect(true));
      dispatch(resetPositionSocketSlice());
    };
  }, []);
  useEffect(() => {
    if (Object.keys(params)?.length == 0) {
      setSearchParams({ userId: loginUserId });
    }
  }, [params]);
  useEffect(() => {
    if (!data) return;
    const grouped = {};
    if (value?.radioClient === 0) {
      // Client wise - Backend now sends grouped data or list of positions with user info
      // If backend sends flat list, we group it. If backend sends grouped, we adapt.
      // Based on user: "logic is moved to backend", let's assume it might still need some mapping if we want to keep the current object structure for the table.
      data?.forEach((el) => {
        const userID =
          el.groupKey ||
          `${el?.user?.[0]?.accountName}_${el?.user?.[0]?.userId}`;
        (grouped[userID] ||= []).push(...(el.positions || [el]));
      });
      setPosition(grouped);
    } else {
      // Script wise
      data?.forEach((el) => {
        const symbolKey = el.groupKey || el?.symbol;
        (grouped[symbolKey] ||= []).push(...(el.positions || [el]));
      });
      setPosition(grouped);
    }
  }, [data, value?.radioClient]);
  useEffect(() => {
    if (data && data?.length > 0) {
      const list = data.map((el) => el.groupId || el._id);
      const payload = {
        groupBy: value?.radioClient === 0 ? "clientwise" : "symbolwise",
        status:
          value?.radioAll === 2
            ? "all"
            : value?.radioAll === 3
            ? "open"
            : "close",
        list: list,
      };
      doSendPosition({ event: "subscribeToPosition", payload });
    }
  }, [data, value?.radioClient, value?.radioAll]);

  // // compute group totals in one place (pnl and mtm)
  useEffect(() => {
    const worker = new Worker(new URL("./totalPNLWorker.js", import.meta.url));
    let intervalId;
    worker.onmessage = (e) => {
      const { key, total } = e.data;
      setGroupTotals((prev) =>
        prev[key] === total ? prev : { ...prev, [key]: total }
      );
    };
    const tick = () => {
      const prices = store?.getState?.()?.positionSocketSlice?.data || {};
      // post each group to the worker (worker is cheap, posts are small numbers)
      Object.keys(position || {}).forEach((key) => {
        const group = position[key] || [];
        worker.postMessage({ key, data: group, prices });
      });
    };
    // start polling only when there is any group
    if (position && Object.keys(position).length) {
      tick();
      intervalId = setInterval(tick, 1000);
    }
    return () => {
      if (intervalId) clearInterval(intervalId);
      worker.terminate();
    };
  }, [position]);

  // function
  const handleExit = () => {
    let obj = currentPriceRef.current;
    let finalPrice = [];
    let keyArray = [];

    for (let key in obj) {
      let arrayData = obj[key]?.map((el) => {
        const isOne = obj[key]?.length === 1 && position[key]?.length === 1;
        const isFull = obj[key]?.length === position[key]?.length;
        if (isOne || isFull) {
          keyArray.push(key);
        }
        return {
          id: el?.id,
          tradePrice: 0,
          High: 0,
          Low: 0,
        };
      });
      finalPrice = [...finalPrice, ...arrayData];
    }

    if (finalPrice?.length > 0) {
      let payload = {
        deviceType: "web",
        positionIds: finalPrice,
        tradeIpAddress: userIP,
        type: "CloseAll",
      };
      setClosePositionLoading(true);
      closePosition(payload, keyArray);
    } else {
      notification.error({ message: "Please select position before exit" });
    }
  };
  const handleRollover = async () => {
    let obj = currentPriceRef.current;
    // return console.log("obj", obj);
    let finalPrice = [];

    for (let key in obj) {
      const priceArray = obj[key]?.map((el) => {
        return { id: el?.id, tradePrice: 0 };
      });
      finalPrice = [...finalPrice, ...priceArray];
    }

    if (finalPrice?.length <= 0) {
      return notification.error({
        message: "Please select position before rollover",
      });
    }

    let payload = {
      deviceType: "web",
      positionIds: finalPrice,
      tradeIpAddress: userIP,
      type: "rollover",
    };
    setRolloverLoading(true);
    try {
      let response = await APICall("post", EndPoints.rollOverPosition, payload);
      if (response.status === 200) {
        setClearSelect(true);
        currentPriceRef.current = {};
        notification.success({ message: response?.data?.message });
      } else {
        notification.error({ message: response?.data?.message });
      }
    } catch (error) {
      notification.error({ message: error?.message });
    } finally {
      setRolloverLoading(false);
    }
  };
  const closePosition = async (obj, indexArray) => {
    try {
      let response = await APICall("post", EndPoints.closePosition, obj);
      if (response.status === 200) {
        notification.success({ message: response?.data?.message });
        setClearSelect(true);
        currentPriceRef.current = {};
        if (indexArray?.length > 0) {
          if (activeRef.current) {
            const collapse = activeRef.current.querySelector(".ant-collapse");
            if (collapse) {
              indexArray.forEach((el) => {
                const panelHeader = collapse.querySelector(
                  `[data-key="${el}"].ant-collapse-item-active .ant-collapse-header`
                );
                if (panelHeader) {
                  panelHeader.click();
                }
              });
            }
          }
        }
      } else {
        notification.error({ message: response?.data?.message, duration: 10 });
      }
    } catch (error) {
      notification.error({ message: error.message });
    } finally {
      setClosePositionLoading(false);
    }
  };
  const handleDate = (date, string, name) => {
    setValue({ ...value, [name]: date });
  };
  const handleClear = () => {
    dispatch(setUserClearFilter(true));
    valueRef.current = {};
    setValue({
      radioClient: isCustomer ? 1 : 0,
      radioAll: 2,
      asOnDate: null,
    });
    setCurrentPage(1);
    setSearchParams({ userId: loginUserId });
  };
  const findTrade = async () => {
    let payloadValue = valueRef.current;
    let valueObj = {
      userId: payloadValue?.userId || loginUserId,
      marketName: payloadValue?.value?.marketName || null,
      symbolName: payloadValue?.value?.symbolName || null,
      expiryDate: payloadValue?.value?.expiryDate || null,
      asOnDate: value?.asOnDate?.toISOString() || null,
      valanId: payloadValue?.valan || null,
    };

    for (let key in valueObj) {
      if (!valueObj[key]) {
        delete valueObj[key];
      }
    }

    setCurrentPage(1);
    setSearchParams(valueObj);
  };
  const onChangeRadio = (e) => {
    if (activeRef.current) {
      const collapse = activeRef.current.querySelector(".ant-collapse");
      if (collapse) {
        // Find and click all expanded headers to close them
        const expandedPanels = collapse.querySelectorAll(
          ".ant-collapse-item-active .ant-collapse-header"
        );
        expandedPanels.forEach((header) => {
          header.click();
        });
      }
    }
    const val = e.target.value;
    setCurrentPage(1);
    if (val === 0 || val === 1) {
      setValue((pre) => ({ ...pre, radioClient: val }));
    } else {
      setValue((pre) => ({ ...pre, radioAll: val }));
    }
  };

  // collapse items
  const CollapseItem = useMemo(
    () =>
      Object.keys(position)?.map((el, index) => {
        return {
          key: el,
          label: (
            <StyledLabel>
              <div>
                <span>
                  {value?.radioClient === 0
                    ? `${position[el][0]?.user[0]?.accountName} (${position[el][0]?.user[0]?.userId}) : `
                    : `${ScriptName(position[el][0])}
                     ${
                       position[el][0]?.expiryDate
                         ? valanBillDate(position[el][0]?.expiryDate, false)
                         : ""
                     } : `}
                </span>
                <TotalPNL
                  data={position[el]}
                  precomputed={groupTotals[el]}
                  groupId={el}
                />
              </div>
              <TitleRow>
                <Col xs={24} lg={12}>
                  <TotalOutstanding
                    data={position[el]}
                    value={value}
                    type="market"
                  />
                </Col>
                <Col xs={24} lg={12}>
                  <TotalOutstanding
                    data={position[el]}
                    value={value}
                    type="intraday"
                  />
                </Col>
              </TitleRow>
            </StyledLabel>
          ),
          children: (
            <PositionTable
              position={position}
              closePosition={closePosition}
              currentPriceRef={currentPriceRef}
              value={value}
              el={el}
              clearSelect={clearSelect}
              setClearSelect={setClearSelect}
              isBroker={isBroker}
            />
          ),
          "data-key": el,
        };
      }),
    [position, value?.radioClient, groupTotals]
  );

  return (
    <>
      <ThemeCard>
        <Row
          gutter={[20, 20]}
          justify={"center"}
          style={{ marginBottom: "2rem" }}
        ></Row>
        <Row gutter={[10, 15]} style={{ alignItems: "center" }}>
          {!isCustomer && (
            <Col
              xs={24}
              sm={12}
              md={8}
              lg={6}
              xl={4}
              style={{ marginTop: "0.5rem", textAlign: "center" }}
            >
              <MarketTypeRadio
                options={options1}
                onChange={onChangeRadio}
                value={value?.radioClient}
                optionType="button"
                buttonStyle="solid"
                width={"46%"}
              />
            </Col>
          )}
          <Col
            xs={24}
            sm={12}
            md={8}
            lg={6}
            xl={4}
            style={{ marginTop: "0.5rem", textAlign: "center" }}
          >
            <MarketTypeRadio
              options={options2}
              onChange={onChangeRadio}
              value={value.radioAll}
              optionType="button"
              buttonStyle="solid"
              width={"46%"}
            />
          </Col>
          <MarketScriptList valueRef={valueRef} />
          {isOwner && <ValanComponant valueRef={valueRef} />}
          <Col xs={24} sm={12} md={8} lg={6} xl={4}>
            <ThemeDatePicker
              title="As on Date"
              name="asOnDate"
              width="100%"
              showTime={{
                format: "HH:mm",
              }}
              format="YYYY-MM-DD HH:mm"
              placeholder="Select Date"
              onChange={(date, string) => handleDate(date, string, "asOnDate")}
              value={value?.asOnDate}
            />
          </Col>

          {!isCustomer && !isBroker && (
            <UserFilterComponant valueRef={valueRef} />
          )}
        </Row>

        <Row style={{ marginTop: "3rem" }} gutter={[10, 10]}>
          <Col xs={24} sm={12} md={4} lg={3} xl={2}>
            <StyledButton type="primary" onClick={findTrade}>
              Search
            </StyledButton>
          </Col>
          {!isBroker && (
            <Col xs={24} sm={12} md={4} lg={3} xl={2}>
              <StyledButton
                onClick={handleRollover}
                type="primary"
                loading={rolloverLoading}
              >
                Rollover
              </StyledButton>
            </Col>
          )}
          {!isBroker && (
            <Col xs={24} sm={12} md={4} lg={3} xl={2}>
              <StyledButton
                type="primary"
                onClick={handleExit}
                loading={closePositionLoading}
              >
                Exit Position
              </StyledButton>
            </Col>
          )}
          <Col xs={24} sm={12} md={4} lg={3} xl={2}>
            <StyledButton type="primary" onClick={handleClear}>
              Clear Filter
            </StyledButton>
          </Col>
        </Row>

        <div style={{ marginTop: "2rem" }}>
          <Collapse
            items={[
              {
                key: "debug",
                label: (
                  <span style={{ fontWeight: 600 }}>
                    Debug Section (Socket m2mUpdate)
                  </span>
                ),
                children: (
                  <div
                    style={{
                      maxHeight: "300px",
                      overflowY: "auto",
                      background: "#f5f5f5",
                      padding: "1rem",
                      borderRadius: "8px",
                    }}
                  >
                    {socketLogs?.length === 0
                      ? "No socket traffic recorded yet..."
                      : socketLogs.map((log, index) => (
                          <div
                            key={index}
                            style={{
                              marginBottom: "1rem",
                              borderBottom: "1px solid #ddd",
                              paddingBottom: "0.5rem",
                              position: "relative",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginBottom: "4px",
                              }}
                            >
                              <span
                                style={{
                                  padding: "2px 6px",
                                  borderRadius: "4px",
                                  fontSize: "10px",
                                  fontWeight: "bold",
                                  background:
                                    log.type === "EMIT" ? "#e6f7ff" : "#f6ffed",
                                  color:
                                    log.type === "EMIT" ? "#1890ff" : "#52c41a",
                                  border: `1px solid ${
                                    log.type === "EMIT" ? "#91d5ff" : "#b7eb8f"
                                  }`,
                                }}
                              >
                                {log.type}: {log.event}
                              </span>
                              <span style={{ fontSize: "11px", color: "#999" }}>
                                {new Date(log.updatedAt).toLocaleTimeString()}
                              </span>
                            </div>
                            <pre
                              style={{
                                margin: 0,
                                fontSize: "11px",
                                color: "#444",
                                overflowX: "auto",
                              }}
                            >
                              {JSON.stringify(log.payload, null, 2)}
                            </pre>
                          </div>
                        ))}
                  </div>
                ),
              },
            ]}
          />
        </div>
      </ThemeCard>

      <ThemeCard style={{ marginTop: "2rem" }}>
        <StyleRow gutter={[10, 10]}>
          <Col xs={24} sm={12} md={6} lg={3} xl={3} style={style.colCardText}>
            <CardTitleText>TOTAL MTM</CardTitleText>
            <CardDetailText>
              <span
                style={{
                  color: (m2mSummary?.totalM2M || 0) >= 0 ? "green" : "red",
                }}
              >
                {formatToINR(m2mSummary?.totalM2M || 0)}
              </span>
            </CardDetailText>
          </Col>

          <Col xs={24} sm={12} md={6} lg={3} xl={3} style={style.colCardText}>
            <CardTitleText>BUY QTY </CardTitleText>
            <CardDetailText>
              <span style={{ color: "green" }}>
                {formatToINR(m2mSummary?.totalBuyQuantity || 0)}
              </span>
            </CardDetailText>
          </Col>
          <Col xs={24} sm={12} md={6} lg={3} xl={3} style={style.colCardText}>
            <CardTitleText>SELL QTY</CardTitleText>
            <CardDetailText>
              <span style={{ color: "red" }}>
                {formatToINR(m2mSummary?.totalSellQuantity || 0)}
              </span>
            </CardDetailText>
          </Col>
          <Col xs={24} sm={12} md={6} lg={3} xl={3} style={style.colCardText}>
            <CardTitleText>OUTSTANDING(LOT)</CardTitleText>
            <CardDetailText>
              {formatToINR(m2mSummary?.outstandingQuantity || 0)}
              {m2mSummary?.outstandingLot > 0 &&
                ` (${formatNumber(m2mSummary?.outstandingLot)})`}
            </CardDetailText>
          </Col>
          <Col xs={24} sm={12} md={6} lg={3} xl={3} style={style.colCardText}>
            <CardTitleText>NET QTY(LOT)</CardTitleText>
            <CardDetailText>
              <span
                style={{
                  color:
                    (m2mSummary?.netQuantity || 0) > 0
                      ? "#52c41a"
                      : (m2mSummary?.netQuantity || 0) < 0
                      ? "#ff4d4f"
                      : "inherit",
                  fontWeight: 500,
                }}
              >
                {(m2mSummary?.netQuantity || 0) > 0 ? "+" : ""}
                {formatToINR(m2mSummary?.netQuantity || 0)}
                {Math.abs(m2mSummary?.newQuantityLot || 0) > 0 &&
                  ` (${formatNumber(
                    Math.abs(m2mSummary?.newQuantityLot || 0)
                  )})`}
              </span>
            </CardDetailText>
          </Col>
        </StyleRow>
      </ThemeCard>

      <div style={style.tableWrraperDiv}>
        {isLoading ? (
          <Skeleton active />
        ) : (
          <>
            {Object.keys(position)?.length == 0 ? (
              <Collapse
                style={style.collapse}
                items={[
                  {
                    key: "1",
                    label: <StyledLabel>No data found</StyledLabel>,
                  },
                ]}
              />
            ) : (
              <div ref={activeRef}>
                <Collapse
                  accordion
                  items={CollapseItem}
                  style={style.collapse}
                />
                <div
                  style={{
                    marginTop: "1rem",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Pagination
                    current={currentPage}
                    pageSize={pageSize}
                    total={totalCount}
                    onChange={(page, size) => {
                      setCurrentPage(page);
                      setPageSize(size);
                    }}
                    showSizeChanger
                    pageSizeOptions={["10", "20", "50", "100"]}
                  />
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
}

export default TradingPosition;

const quantityCalculation = (data, type) => {
  const totalBuy = data?.reduce((acc, el) => {
    return acc + (el?.totalBuyQuantity || 0);
  }, 0);

  const totalSell = data?.reduce((acc, el) => {
    return acc + el?.totalSellQuantity;
  }, 0);

  if (type === "buy") {
    return totalBuy;
  } else if (type === "sell") {
    return totalSell;
  } else {
    const totalQty = data?.reduce((acc, el) => {
      return acc + (Math.abs(el?.totalQuantity) || 0);
    }, 0);
    return totalQty;
  }
};

const sortedObj = (obj, type) => {
  const keys = Object.keys(obj);
  let newObj = {};
  if (type === "symbolWise") {
    keys.sort((a, b) =>
      obj[a][0].symbolName.localeCompare(obj[b][0].symbolName)
    );
    keys.forEach((el) => {
      newObj[`${obj[el][0]?.symbolName}_${el}`] = obj[el];
    });
    return newObj;
  } else {
    keys.sort((a, b) => a.localeCompare(b));
    keys.forEach((el) => {
      newObj[el] = obj[el];
    });
    return newObj;
  }
};
